import { useEffect, useState } from "react";
import { Users, UserCheck, Clock, PiggyBank, HandCoins, ArrowUpRight } from "lucide-react";
import AdminLayout from "../components/AdminLayout";
import StatCard from "../components/StatCard";
import { api, formatRupiah } from "../lib/api";
import { Link } from "react-router-dom";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [pendingMembers, setPendingMembers] = useState([]);

  useEffect(() => {
    api.get("/admin/dashboard/stats").then((r) => setStats(r.data));
    api.get("/admin/members", { params: { status: "pending" } }).then((r) => setPendingMembers(r.data));
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-8">
        <div>
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight text-brand-ink">Dashboard</h1>
          <p className="text-brand-muted text-sm mt-1">Ringkasan statistik koperasi secara real-time.</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-stats">
          <StatCard testid="stat-total-members" label="Total Anggota" value={stats?.total_members ?? "—"} icon={Users} accent="brand" />
          <StatCard testid="stat-active-members" label="Anggota Aktif" value={stats?.active_members ?? "—"} icon={UserCheck} accent="success" />
          <StatCard testid="stat-pending-members" label="Menunggu Approval" value={stats?.pending_members ?? "—"} icon={Clock} accent="gold" />
          <StatCard testid="stat-pending-pinjaman" label="Pinjaman Pending" value={stats?.pending_pinjaman ?? "—"} icon={HandCoins} accent="info" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <StatCard testid="stat-total-simpanan" label="Total Simpanan" value={formatRupiah(stats?.total_simpanan)} icon={PiggyBank} accent="brand" sub="Pokok+Wajib+Sukarela" />
          <StatCard testid="stat-simpanan-pokok" label="Simpanan Pokok" value={formatRupiah(stats?.total_simpanan_pokok)} icon={PiggyBank} accent="info" />
          <StatCard testid="stat-simpanan-wajib" label="Simpanan Wajib" value={formatRupiah(stats?.total_simpanan_wajib)} icon={PiggyBank} accent="success" />
        </div>

        <section className="bg-white rounded-3xl p-5 sm:p-7 border border-brand/10 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h2 className="font-heading font-bold text-brand-ink text-xl">Anggota Menunggu Persetujuan</h2>
              <p className="text-xs text-brand-muted">Verifikasi dan setujui pendaftaran baru</p>
            </div>
            <Link
              to="/admin/members?status=pending"
              data-testid="dashboard-view-all-pending"
              className="text-sm rounded-full bg-brand-soft text-brand px-4 py-2 hover:bg-brand-soft/70 inline-flex items-center gap-1"
            >
              Lihat Semua <ArrowUpRight size={14} />
            </Link>
          </div>

          {pendingMembers.length === 0 ? (
            <div className="rounded-2xl border border-dashed border-brand/20 p-10 text-center text-brand-muted">
              Tidak ada pendaftaran menunggu persetujuan.
            </div>
          ) : (
            <ul className="divide-y divide-brand/10">
              {pendingMembers.slice(0, 6).map((m) => (
                <li key={m.id} className="py-3 flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-medium text-brand-ink truncate">{m.full_name}</div>
                    <div className="text-xs text-brand-muted">{m.email} · {m.phone}</div>
                  </div>
                  <Link
                    to={`/admin/members?id=${m.id}`}
                    className="text-sm rounded-full bg-brand text-white px-4 py-1.5 hover:bg-brand-hover transition"
                    data-testid={`open-member-${m.id}`}
                  >
                    Tinjau
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </AdminLayout>
  );
}
